var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitePen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9709 1.92665C17.3494 1.84049 18.7089 2.31916 19.7333 3.25736C20.6715 4.28172 21.1501 5.64114 21.0735 7.02929V15.9709C21.1597 17.359 20.6715 18.7184 19.7428 19.7428C18.7185 20.681 17.3494 21.1597 15.9709 21.0735H7.02921C5.64105 21.1597 4.28161 20.681 3.25725 19.7428C2.31904 18.7184 1.84037 17.359 1.92653 15.9709V7.02929C1.84037 5.64114 2.31904 4.28172 3.25725 3.25736C4.28161 2.31916 5.64105 1.84049 7.02921 1.92665H15.9709ZM10.5235 16.1432L16.9665 9.68113C17.5505 9.08758 17.5505 8.13023 16.9665 7.54626L15.722 6.30171C15.1284 5.70816 14.171 5.70816 13.5775 6.30171L12.9361 6.9527C12.8403 7.04844 12.8403 7.21118 12.9361 7.30692C12.9361 7.30692 14.4583 8.81952 14.487 8.85781C14.5923 8.9727 14.6593 9.12587 14.6593 9.29819C14.6593 9.64284 14.3817 9.93004 14.0274 9.93004C13.8647 9.93004 13.7115 9.86302 13.6062 9.75772L12.0074 8.16853C11.9308 8.09194 11.7968 8.09194 11.7202 8.16853L7.15367 12.7351C6.83774 13.051 6.65584 13.4722 6.64627 13.9222L6.58883 16.1911C6.58883 16.3155 6.62712 16.4304 6.71328 16.5166C6.79945 16.6027 6.91433 16.6506 7.03878 16.6506H9.28856C9.74809 16.6506 10.1885 16.4687 10.5235 16.1432Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePen);
export default __webpack_public_path__ + "static/media/white_pen.a2a0fc6b6f1b2dd5bbdf85420e6ea5cc.svg";
export { ForwardRef as ReactComponent };